import React, {FC} from 'react';
import {connect} from "react-redux";
import Recommendations from "../../components/Main/Recommendations";
import {getAuthorCompilations, getHookahCompilations, getOurCompilations} from "../../services/selectionSelector";
import {
    fetchMixCompilation, setCurrentCompilations,
    setSelectedIndexCompilations,
    setTobaccoIndex
} from "../../modules/Main";
import {ICompilation, IMix} from "../../constants/types";

interface IRecommendationsPage {
    mixWeek: IMix,
    popularMixes: Array<IMix>,
    isLoading: boolean,
    isUserAuth: boolean,
    setTobaccoIndex: any,
    ourCompilations: Array<ICompilation>,
    hookahCompilations: Array<ICompilation>,
    authorCompilations: Array<ICompilation>,
    setIndexCompilations: any,
    fetchMixCompilation: any,
    setCurrentCompilations: any,
    recommendedMixes: Array<ICompilation>,
}

const RecommendationsPage: FC<IRecommendationsPage> = ({
                                                           setTobaccoIndex,
                                                           popularMixes,
                                                           mixWeek,
                                                           ourCompilations,
                                                           hookahCompilations,
                                                           authorCompilations,
                                                           fetchMixCompilation,
                                                           setCurrentCompilations,
                                                           setIndexCompilations }) => {


    return (
            <Recommendations
                setTobaccoIndex={setTobaccoIndex}
                popularMixes={popularMixes}
                mixWeek={mixWeek}
                ourCompilations={ourCompilations}
                hookahCompilations={hookahCompilations}
                authorCompilations={authorCompilations}
                setIndexCompilations={setIndexCompilations}
                fetchMixCompilation={fetchMixCompilation}
                setCurrentCompilations={setCurrentCompilations}
            />
    )
};

const mapStateToProps = (state: any) => ({
    mixWeek: state.main.mixWeek,
    popularMixes: state.main.popularMixes,
    isLoading: state.main.isLoading,
    ourCompilations: getOurCompilations(state),
    hookahCompilations: getHookahCompilations(state),
    authorCompilations: getAuthorCompilations(state),
    isUserAuth: state.system.isUserAuth,
    recommendedMixes: state.main.recommendedMixes
});

const mapDispatchToProps = (dispatch: any) => ({
    setTobaccoIndex: (id: number) => dispatch(setTobaccoIndex(id)),
    setIndexCompilations: (id: number) => dispatch(setSelectedIndexCompilations(id)),
    fetchMixCompilation: (id: number) => dispatch(fetchMixCompilation(id)),
    setCurrentCompilations: (id: number, isGroupCard?: number) => dispatch(setCurrentCompilations(id, isGroupCard)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RecommendationsPage );

